import React from 'react';
import { QueryClientProvider } from 'react-query';
import Routes from './components/routes';
import { ReactQueryDevtools } from 'react-query/devtools';
import 'utils/FormioOverrides';
import { Provider } from 'react-redux';
import Store from './store';
import queryClient from 'utils/queryClient';
import { BrowserRouter as Router } from 'react-router-dom';
// Base App component
export default function App() {
  let consoleHolder = console;

  function debug(bool) {
    if (!bool) {
      consoleHolder = console;
      // eslint-disable-next-line no-global-assign
      console = {};
      Object.keys(consoleHolder).forEach(function (key) {
        console[key] = function () {};
      });
    } else {
      // eslint-disable-next-line no-global-assign
      console = consoleHolder;
    }
  }

  debug(true);

  return (
    <Router>
      <Provider store={Store}>
        <QueryClientProvider client={queryClient}>
          <Routes />
          <ReactQueryDevtools initialIsOpen={false} />
        </QueryClientProvider>
      </Provider>
    </Router>
  );
}
